import { ContainerStatusEnum,BlStatusEnum } from "@gtpl/shared-models/common-models";
import { SaleOrderDropDownDto } from "@gtpl/shared-models/sale-management";
import { ApiProperty } from "@nestjs/swagger";
import { IsEnum, IsNotEmpty } from "class-validator";

export class DraftReceived{
    @ApiProperty()
    containerNo:string;
    @ApiProperty()
    saleOrder:SaleOrderDropDownDto;
    @ApiProperty({enum:Object.values(BlStatusEnum)})
    @IsNotEmpty()
    @IsEnum(BlStatusEnum)
    blStatus:BlStatusEnum;
    @ApiProperty()
    containerId?:number;
    @ApiProperty()
    etd?:Date;
    @ApiProperty()
    blNo?:string;

   /**
    * 
    * @param containerNo 
    * @param saleOrder 
    * @param blStatus 
    * @param containerId 
    * @param etd 
    * @param blNo 
    */
    constructor(containerNo:string, saleOrder:SaleOrderDropDownDto, blStatus:BlStatusEnum, containerId?:number, etd?:Date, blNo?:string ){
        this.containerNo = containerNo;
        this.saleOrder = saleOrder;
        this.blStatus = blStatus;
        this.containerId = containerId;
        this.etd = etd;
        this.blNo = blNo;
    }
}